import { Example } from "../models/ExampleModel";
import { ExplanationModel } from "../models/ExplanationModel";
import { ConjugationTableData } from "../models/table-models/ConjugationTableDataModel";
import { VerbConjugation } from "../models/VerbConjugationModel";

export const futuroImperfectoExplanation: ExplanationModel = {
    title: "📖 What is Futuro Imperfecto?",
    description: `
      The Futuro Imperfecto (Simple Future) is used to express actions that will happen in the future.
  
  
    `.trim(),
    bulletPoints: [
        "Used to talk about future events or plans. ➝ 'Iré a la universidad el próximo año.' (I will go to university next year.)",
        "Used to make predictions about the future. ➝ 'Lloverá mañana por la tarde.' (It will rain tomorrow afternoon.)",
        "Expresses probability or assumptions about the present. ➝ '¿Dónde está Juan? → Estará en su casa.' (Where is Juan? → He is probably at home.)"
    ],
    examples: [
        "📌 Structure: Infinitive + Future Endings",
    ]
};

export const FuturoImperfectoExamplesData: Example[] = [
    {
        sentence: "Mañana viajaré a España.",
        explanation: "✈️ Future Plan – 'Tomorrow I will travel to Spain.' This expresses a planned action in the future."
    },
    {
        sentence: "El año que viene estudiaré en Francia.",
        explanation: "📚 Future Intention – 'Next year I will study in France.' This demonstrates a long-term plan."
    },
    {
        sentence: "¿Qué harás después del trabajo?",
        explanation: "🕒 Future Question – 'What will you do after work?' This asks about a future event."
    },
    {
        sentence: "Lloverá mañana, seguro.",
        explanation: "🌧️ Prediction – 'It will rain tomorrow, for sure.' This expresses a weather prediction."
    },
    {
        sentence: "Juan estará en casa ahora mismo.",
        explanation: "🏠 Assumption – 'Juan will be at home right now.' This sentence uses the future tense to express probability in the present."
    }
];

export const futuroImperfectoRegular: ConjugationTableData = new ConjugationTableData(
    "Regular Verbs",
    [
        new VerbConjugation("Hablar", ["hablaré", "hablarás", "hablará", "hablaremos", "hablaréis", "hablarán"]),
        new VerbConjugation("Comer", ["comeré", "comerás", "comerá", "comeremos", "comeréis", "comerán"]),
        new VerbConjugation("Vivir", ["viviré", "vivirás", "vivirá", "viviremos", "viviréis", "vivirán"])
    ]
);

export const futuroImperfectoIrregular: ConjugationTableData = new ConjugationTableData(
    "Irregular Verbs",
    [
        new VerbConjugation("Tener", ["tendré", "tendrás", "tendrá", "tendremos", "tendréis", "tendrán"]),
        new VerbConjugation("Hacer", ["haré", "harás", "hará", "haremos", "haréis", "harán"]),
        new VerbConjugation("Decir", ["diré", "dirás", "dirá", "diremos", "diréis", "dirán"]),
        new VerbConjugation("Poner", ["pondré", "pondrás", "pondrá", "pondremos", "pondréis", "pondrán"]),
        new VerbConjugation("Salir", ["saldré", "saldrás", "saldrá", "saldremos", "saldréis", "saldrán"]),
        new VerbConjugation("Poder", ["podré", "podrás", "podrá", "podremos", "podréis", "podrán"]),
        new VerbConjugation("Saber", ["sabré", "sabrás", "sabrá", "sabremos", "sabréis", "sabrán"]),
        new VerbConjugation("Haber", ["habré", "habrás", "habrá", "habremos", "habréis", "habrán"])
    ]
);